import { useContext } from 'react';
import { BsFileEarmarkExcel, BsKanban, BsKanbanFill } from "react-icons/bs";
import { ButtonLoading, ButtonToggle } from "../../../components/button/Button";
import { FeatureContext } from "../../../Context";
import { lang } from '../../../Utils';
import { downloadOrderDetails } from '../Services';

const Actions = () => {

  const context = useContext(FeatureContext);

  return (
    <div className="bf-actions">
      {(context?.currentTab === 0) ? <>
        <ButtonToggle
          on={<BsKanban />}
          off={<BsKanbanFill />}
          onClick={context?.toggleKanbanState} />
        <ButtonLoading
          disabled={!context?.details}
          callback={downloadOrderDetails}
          args={{ orderId: context?.details?.slice(0, 1)[0]?.salesOrderNumber, section: 'salesOrderDetail' }}
          icon={<BsFileEarmarkExcel />}
          label={lang('Excel')} />
      </> : null}

      {(context?.currentTab === 1) ? <>
        <ButtonLoading
          disabled={!context?.details}
          callback={downloadOrderDetails}
          args={{ orderId: context?.details?.slice(0, 1)[0]?.salesOrderNumber, section: 'invoiceDetail' }}
          icon={<BsFileEarmarkExcel />}
          label={lang('Excel')} />
      </> : null}
      
    </div>
  )
}
export default Actions;